import dateFormat, { formatDateTime } from "../../../../../utils/dateFormat";

export const recordDetailsheader = [
  "Name",
  "Date Locked",
  // "Locked By",
  "Inquire by",
  "Affiliate",
  "Branch",
];

export const recordDetailsBody = (object) => {
  console.log("qwqwq", object);
  if (!object) return;

  const { firstName, middleName, lastName, lockedTo } = object || {};

  console.log(firstName, middleName, lastName);

  const dateDisplay = object?.lockedDateString
    ? formatDateTime(object?.lockedDateString)
    : dateFormat(object.updatedAt);

  const recordDetailsBody = [
    [
      object?.company
        ? object?.company
        : `${firstName} ${middleName || ""} ${lastName}`,
      // dateFormat(object?.createdAt),
      dateDisplay,
      lockedTo
        ? `${lockedTo.firstName || ""} ${lockedTo.middleName || ""} ${
            lockedTo.lastName || ""
          }`
        : "None",
      lockedTo?.affiliate?.name || "None",
      lockedTo?.branch?.name || "None",
    ],
  ];

  return recordDetailsBody;
};
